module.exports = __webpack_public_path__ + "media/images/booth/chief_editor-84f9504bedc0884642c554b7731f386d.png";